import { ThemeProvider } from '@mui/material';
import './App.css';
import Theme from "./components/Style/Theme"
import AppRouter from './components/Router/AppRouter';
import ErrorBoundary from './components/ErrorBoundary/ErroryBoundary';
import { BrowserRouter } from "react-router-dom";
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';


const App = () => {
    // return (<Test />)
    const queryClient = new QueryClient()
    return (
        <QueryClientProvider client={queryClient}>
        <ThemeProvider theme={Theme}>
            <ErrorBoundary>
                <BrowserRouter basename={process.env.REACT_APP_PUBLIC_URL}>
                    <AppRouter />
                </BrowserRouter>
            </ErrorBoundary>
        </ThemeProvider>
        </QueryClientProvider>
    )
}

export default App;
